module.exports = __webpack_public_path__ + "media/audio2.24af54b7.mp3";